import angular from 'angular';
import uiSelect from 'ui-select';
import localStorageService from 'angular-local-storage';
import * as agGrid from 'ag-grid/main';
import pagination from '../PaginationControls/PaginationControlsModule'
import gettext from 'angular-gettext';

agGrid.initialiseAgGridWithAngular1(angular);

export default angular.module('cms.grid.directive', ['agGrid', uiSelect, pagination, localStorageService, gettext]).component('cmsGrid', {
    template: require('./grid.html'),
    bindings: {
        gridOptions: '=',
        datasource: '=',
        initialSortModel: '=?',
        initialFilterModel: '=?',
        initialPage: '=?',
        onPageChange: '&?'
    },
    controller: function ($scope, localStorageService, gettextCatalog) {

        this.itemsPerPage = 20;
        this.itemsPerPageSelect = [20, 50, 100];

        let getConstrainsLocaleTexts = () => {
            return {
                contains: gettextCatalog.getString('Contains'),
                equals: gettextCatalog.getString('Equals'),
                notEqual: gettextCatalog.getString('Not equal'),
                startsWith: gettextCatalog.getString('Starts with'),
                endsWith: gettextCatalog.getString('Ends with'),
                notContains: gettextCatalog.getString('Not contains'),
                inRange: gettextCatalog.getString('In range'),
            }
        };

        this.$onInit = () => {

            if (typeof this.gridOptions._columnDefsCallback === 'function') {
                this.gridOptions.columnDefs = this.gridOptions._columnDefsCallback();
            }

            // Add Rows spinner
            if (this.gridOptions.columnDefs[0]) {
                this.gridOptions.columnDefs[0].cellRenderer = function (params) {
                    if (params.value !== undefined) {
                        return params.value;
                    } else {
                        return '<i class="fa fa-spin fa-circle-o-notch"></i>';
                    }
                };
            }

            /**
             * @see https://www.ag-grid.com/javascript-grid-infinite-scrolling/#gsc.tab=0
             */
            this.gridOptions = angular.merge({

                rowModelType: 'infinite',

                pagination: true,
                suppressPaginationPanel: true,
                paginationPageSize: this.itemsPerPage,

                enableServerSideSorting: true,
                enableServerSideFilter: true,
                enableColResize: true,
                floatingFilter: true,
                autoHeight: true,
                _gridStateId: undefined,
                headerHeight: 36,
                rowHeight: 36,
                floatingFiltersHeight: 38,
                localeText: getConstrainsLocaleTexts(),

                onPaginationChanged: () => {
                    $scope.$apply();
                    let currentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
                    if(this.onPageChange) {
                        this.onPageChange({$page: currentPage});

                    }
                },

                onGridReady: () => {
                    if(this.initialSortModel) {
                        this.gridOptions.api.setSortModel(this.initialSortModel)
                    }
                    if(this.initialFilterModel) {
                        this.gridOptions.api.setFilterModel(this.initialFilterModel)
                    }
                    this.gridOptions.api.setDatasource(this.datasource);
                    this.gridOptions.api.sizeColumnsToFit();

                    if(this.gridOptions._gridStateId) {
                        let gridState = localStorageService.get(this.gridOptions._gridStateId);

                        if (gridState) {
                            this.gridOptions.columnApi.setColumnState(gridState);
                        }
                    }

                },
                onColumnResized: (params) => {
                    let columnState = params.columnApi.getColumnState();
                    if(this.gridOptions._gridStateId) {
                        localStorageService.set(this.gridOptions._gridStateId, columnState);
                    }
                },
                onColumnMoved: (params) => {
                    let columnState = params.columnApi.getColumnState();
                    if(this.gridOptions._gridStateId) {
                        localStorageService.set(this.gridOptions._gridStateId, columnState);
                    }
                },

            }, this.gridOptions);

            this.updatePageSize = value => {
                this.gridOptions.api.cacheBlockSize = value;
                this.gridOptions.api.paginationSetPageSize(value);
            };

            this.refreshGrid = () => {
                this.gridOptions.api.paginationGoToFirstPage();
                this.gridOptions.api.setFilterModel(null);
                this.gridOptions.api.setSortModel(null);

                localStorageService.remove(this.gridOptions._gridStateId);

                this.gridOptions.columnApi.resetColumnState();

                this.gridOptions.columnApi.getAllColumns().forEach(function (a) {
                    this.gridOptions.columnApi.autoSizeColumn(a);
                },this);

                this.gridOptions.api.sizeColumnsToFit();
            };

            $scope.$on('language-changed', () => {

                this.gridOptions.api.setColumnDefs(this.gridOptions._columnDefsCallback());
                this.gridOptions.localeText = getConstrainsLocaleTexts();

                let gridState = localStorageService.get(this.gridOptions._gridStateId);

                if (gridState) {
                    this.gridOptions.columnApi.setColumnState(gridState);
                }
            });
        }
    }
}).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Grid/GridDirective.js